/* Swiss CBD — presentation of Judge.me answers. No review data is changed. */
(function () {
  'use strict';
  if (window.scbdReviewInsightsLoaded) return;
  window.scbdReviewInsightsLoaded = true;
  var lang = (document.documentElement.lang || 'fr').slice(0, 2);
  var copy = {
    fr: { region: 'Expérience partagée', more: 'autres motifs', less: 'Réduire', usage: 'Utilisation', quality: 'Qualité globale', feeling: 'Ressenti dominant' },
    en: { region: 'Shared experience', more: 'more reasons', less: 'Show less', usage: 'Use', quality: 'Overall quality', feeling: 'Main feeling' },
    de: { region: 'Geteilte Erfahrung', more: 'weitere Gründe', less: 'Weniger anzeigen', usage: 'Verwendung', quality: 'Gesamtqualität', feeling: 'Empfinden' },
    it: { region: 'Esperienza condivisa', more: 'altri motivi', less: 'Mostra meno', usage: 'Utilizzo', quality: 'Qualità complessiva', feeling: 'Sensazione prevalente' }
  }[lang] || null;
  if (!copy) copy = { region: 'Shared experience', more: 'more reasons', less: 'Show less', usage: 'Use', quality: 'Overall quality', feeling: 'Main feeling' };
  var shortLabels = {
    'Détente / bien-être': 'Détente · bien-être',
    'Stress / tensions du quotidien': 'Stress du quotidien',
    'Réduire ma consommation de cannabis / THC': 'Réduction cannabis / THC',
    'Réduire ma consommation de tabac / nicotine': 'Réduction tabac / nicotine',
    'Réduire ma consommation d’alcool': 'Réduction alcool',
    "Réduire ma consommation d'alcool": 'Réduction alcool',
    'Réduire ma consommation d’autres substances': 'Réduction autres substances',
    "Réduire ma consommation d'autres substances": 'Réduction autres substances',
    'Arômes / plaisir gustatif': 'Plaisir des arômes',
    'Découverte / plaisir': 'Découverte · plaisir',
    'Rapport qualité / prix': 'Qualité / prix'
  };
  var serial = 0;
  function el(tag, className, text) {
    var node = document.createElement(tag);
    node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }
  function icon(kind) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.classList.add('scbd-review-icon');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', kind === 'quality' ? 'm9 12 2 2 4-4 M12 3l7 3v5c0 5-7 10-7 10S5 16 5 11V6Z' : kind === 'feeling' ? 'M3 12h4l3-7 4 14 3-7h4' : 'M20 4C11 3 4 7 5 14c1 6 10 8 13 1 2-4 2-8 2-11ZM5 20 16 9');
    svg.appendChild(path);
    return svg;
  }
  function kindOf(title) {
    var t = title.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    if (/utilisation|utilizzo|usage|verwendung|reduire|consommation|substance/.test(t)) return 'usage';
    if (/qualite globale|overall quality|gesamtqualitat|qualita complessiva/.test(t)) return 'quality';
    if (/ressenti|feeling|empfinden|sensazione|confort apres/.test(t)) return 'feeling';
    return 'other';
  }
  function enhanceAnswer(answer) {
    if (answer.classList.contains('scbd-review-answer')) return;
    var title = answer.querySelector('.jdgm-rev__cf-ans__title');
    var value = answer.querySelector('.jdgm-rev__cf-ans__value');
    if (!title || !value || !value.textContent.trim()) return;
    var type = kindOf(title.textContent);
    answer.classList.add('scbd-review-answer', 'scbd-review-answer--' + type);
    if (type === 'usage') {
      var raw = value.textContent.trim();
      var parts = raw.split(/\s*[,;]\s*/).filter(Boolean);
      var list = el('span', 'scbd-review-tags');
      list.id = 'scbd-review-motifs-' + (++serial);
      parts.forEach(function (part, i) {
        var tag = el('span', 'scbd-review-tag', shortLabels[part] || part);
        if (shortLabels[part]) { tag.title = part; tag.setAttribute('aria-label', part); }
        if (i >= 4) { tag.classList.add('scbd-review-tag--extra'); tag.hidden = true; }
        list.appendChild(tag);
      });
      value.replaceChildren(list);
      if (parts.length > 4) {
        var button = el('button', 'scbd-review-more', '+' + (parts.length - 4) + ' ' + copy.more);
        button.type = 'button';
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', list.id);
        button.addEventListener('click', function () {
          var expand = button.getAttribute('aria-expanded') !== 'true';
          list.querySelectorAll('.scbd-review-tag--extra').forEach(function (tag) { tag.hidden = !expand; });
          button.setAttribute('aria-expanded', String(expand));
          button.textContent = expand ? copy.less : '+' + (parts.length - 4) + ' ' + copy.more;
        });
        value.appendChild(button);
      }
    } else {
      var mark = icon(type);
      answer.insertBefore(mark, title);
    }
  }
  function enhanceReview(review) {
    review.classList.add('scbd-review-card');
    var header = review.querySelector('.jdgm-rev__header');
    var content = review.querySelector('.jdgm-rev__content');
    if (!header || !content) return;
    var rating = content.querySelector('.jdgm-row-rating');
    if (rating) header.appendChild(rating);
    var forms = Array.from(review.querySelectorAll('.jdgm-rev__header-custom-form'));
    var answers = forms.reduce(function (all, form) { return all.concat(Array.from(form.querySelectorAll('.jdgm-rev__cf-ans'))); }, []);
    if (!answers.some(function (a) { return a.textContent.trim(); })) return;
    var panel = review.querySelector('.scbd-review-insights');
    if (!panel) {
      panel = el('section', 'scbd-review-insights');
      panel.setAttribute('aria-label', copy.region);
      var body = content.querySelector('.jdgm-rev__body');
      if (body) body.insertAdjacentElement('afterend', panel);
      else content.appendChild(panel);
    }
    forms.forEach(function (form) { if (form.parentElement !== panel) panel.appendChild(form); });
    answers.forEach(enhanceAnswer);
  }
  var scheduled = false;
  function refresh() {
    scheduled = false;
    document.querySelectorAll('.jdgm-widget .jdgm-rev').forEach(enhanceReview);
  }
  function schedule() {
    if (!scheduled) { scheduled = true; window.requestAnimationFrame(refresh); }
  }
  function init() {
    refresh();
    var observer = new MutationObserver(function (mutations) {
      if (mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (n) {
          return n.nodeType === 1 && !n.closest('.scbd-review-insights') &&
            (n.matches('.jdgm-widget, .jdgm-rev, .jdgm-rev__header-custom-form') || n.querySelector('.jdgm-widget, .jdgm-rev, .jdgm-rev__header-custom-form'));
        });
      })) schedule();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
